import React, { useRef } from "react";
import { GridController, GridTable } from "@ctsu/ctsu-mui-grid";
import { format } from "date-fns";
import { getToken } from "@ctsu/loader";
import { useCurrentUser } from "protocol-setup/helpers/useIsCTSUUser";
import { commaSeparateToSnakeCase, generateDynamicOptions, updateLovValuesToSnakeCase } from "./requestHistoryUtils";
import { USER_ACTION_OPTIONS, UPDATED_STATUS_OPTIONS } from "./requestHistoryLovs";


const formatDate = (dateStr) => {
  if (!dateStr) return '';
  try {
    const parsedDate = new Date(dateStr);
    return format(parsedDate, 'dd-MMM-yyyy hh:mm:ss a');
  } catch (error) {
    return dateStr;
  }
};

const STATUS_HISTORY_COLUMNS = [
  {
    label: "Updated By",
    name: "userAction",
    filter: true,
    sortable: true,
    visible : false
  },
  {
    label: "Updated Status",
    name: "updatedStatus",
    filter: true,
    sortable: true,
    visible : false
  },
  {
    label: "User Action",
    name: "action",
    filter: true,
    sortable: true,
    type: "object",
    options: USER_ACTION_OPTIONS,
    renderCell: (data) => <>{data.userAction}</>
  },
  {
    label: "Updated Status",
    name: "toState",
    filter: true,
    sortable: true,
    type: "object",
    options: UPDATED_STATUS_OPTIONS,
    renderCell: (data) => <>{data.updatedStatus}</>
  },
  {
    label: "Updated Date",
    name: "updatedDate",
    type: "date",
    filter: true,
    sortable: true

  },

  
  {
    label: "Updated By",
    name: "updatedByFormatted",
    filter: true,
    sortable: true,
    renderCell: (data) => <>{data.updatedBy ||"System"}</>
  },
  {
    label: "Updated By",
    name: "updatedBy",
    filter: true,
    sortable: true,
    visible : false
  }
];

const formatStatusHistoryData = (data) => {
  if (!data || !Array.isArray(data)) return [];

  return data.map((item) => ({
    ...item,
    userAction:  USER_ACTION_OPTIONS.find(option => option.value === item.action)?.label || item.action,
    updatedStatus: UPDATED_STATUS_OPTIONS.find(option => option.value === item.toState)?.label || item.toState,
    updatedDate: formatDate(item.effectiveDate),
    updatedBy: item.createdByFullName || "System",
    updatedByFormatted: commaSeparateToSnakeCase(item.createdByFullName || "System")
  }));
};

const StatusHistory = ({ statusHistory, isLoading, error , requestNumber }) => {
  const currentUser = useCurrentUser();
  const gridController = useRef(GridController.createController());



  
  const formatedData = formatStatusHistoryData(statusHistory);

  // Generate dynamic Updated By options from the data
  const updatedByOptions = generateDynamicOptions(formatedData, ["updatedBy"], ["N/A", "System"]);

  const updatedByOptionsSnakeCase = React.useMemo(
    () => updateLovValuesToSnakeCase(updatedByOptions),
    [updatedByOptions]
  );
  // Create columns with dynamic options
  const columnsWithDynamicOptions = STATUS_HISTORY_COLUMNS.map((col) => {
    if (col.name === "updatedByFormatted") {
      return {
        ...col,
        type: "multi",
        options: updatedByOptionsSnakeCase,
        renderCell : (data) => <>{data.updatedBy}</>
      };
    }
    return col;
  });

    if (isLoading) {
    return (
      <div className="d-flex justify-content-center p-4" data-testid="loading-container">
        <div className="spinner-border" role="status" data-testid="loading-spinner">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        Error loading status history: {error.message}
      </div>
    );
  }

  return (
    <GridTable
      id="status-history-grid"
      columns={columnsWithDynamicOptions}
      rows={formatedData}
      filterable
      sortable
      showFilterByDefault={false}
      toPdf={false}
      enableToolbar
      recordPerPage={10}
      getToken={getToken}
      controller={gridController.current}
      defaultSorts={[{ field: "updatedDate", dir: "desc" }]}
      tag="status-history"
      enableInfiniteScroll={false}
      nonExportable={["updatedByFormatted", "id", "action", "toState"]}
      user={currentUser}
      exportTitle={`Protocol Setup Request Status History ${requestNumber}`}
    />
  );
};

export default StatusHistory;
